import { render, staticRenderFns } from "./scenic_area_alert.vue?vue&type=template&id=f4c976a4&scoped=true&"
import script from "./scenic_area_alert.vue?vue&type=script&lang=js&"
export * from "./scenic_area_alert.vue?vue&type=script&lang=js&"
import style0 from "./scenic_area_alert.vue?vue&type=style&index=0&id=f4c976a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c976a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f4c976a4', component.options)
    } else {
      api.reload('f4c976a4', component.options)
    }
    module.hot.accept("./scenic_area_alert.vue?vue&type=template&id=f4c976a4&scoped=true&", function () {
      api.rerender('f4c976a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/tbroc/scenic_area_alert.vue"
export default component.exports